"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const authClient_1 = __importDefault(require("../../utils/authClient"));
const getCurrentUser_1 = __importDefault(require("../users/getCurrentUser"));
const CanisterClientFactory_1 = __importDefault(require("../../services/CanisterClientFactory"));
const SessionExpirationHandler_1 = __importDefault(require("../../domain/SessionExpirationHandler"));
const SESSION_TIMEOUT_NANOS = BigInt(30 * 24 * 60 * 60 * 1000 * 1000 * 1000); // 30 days
function login() {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        let authClient = authClient_1.default();
        yield authClient.login({
            identityProvider: process.env.IDP_URL,
            maxTimeToLive: SESSION_TIMEOUT_NANOS,
            onSuccess: () => __awaiter(this, void 0, void 0, function* () {
                const identity = authClient.getIdentity();
                yield CanisterClientFactory_1.default.init(identity);
                dispatch(getCurrentUser_1.default());
                SessionExpirationHandler_1.default.startSession();
            })
        });
    });
}
exports.default = login;
